import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import BrandDivider from '../BrandDivider';

const NavCard = ({ link, cardImage, image, header, title, description }) => {
  if (!link?.link) return null;
  const linkObj = buildLinkObj(link);
  const imgUrl = buildImageSrc(image || cardImage, 800, 2, 1);

  return (
    <li className="flex-1 md:mx-4 mb-4 md:mb-0 text-center bg-white border border-warm-100">
      <div role="group" aria-label="article">
        <LazyLoadImage imgComponent={<img src={imgUrl} alt="" className="max-w-full" />} />
        <div className="flex-1 flex flex-col p-4">
          {header && <p className="tra-text-web-sub-2 mb-2">{header}</p>}
          {title && <h2 className="tra-text-web-heading-h5">{title}</h2>}
          <BrandDivider />
          {description && <p className="body2 mt-4 flex-1 hover:text-neutral-800">{description}</p>}
          <a rel={getRel(linkObj)} href={linkObj.href} className="flex flex-col h-full">
            <span className="body2 mt-6 underline">{link.displayName}</span>
          </a>
        </div>
      </div>
    </li>
  );
};

export default NavCard;
